import { InternalAxiosRequestConfig } from "axios";
import { TokenStorage } from "../types";

export class AuthInterceptor {
  constructor(private tokenStorage: TokenStorage) {}

  request = async (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> => {
    const token = this.tokenStorage.getAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  };
}
